import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import CreateOptionModal from '../component/CreateOptionModal';
import UpdateOptionModal from '../component/UpdateOptionModal';
import * as actions from '../action';
import * as c from '../constant';

function OptionCalculation({
  newOtherFeesId,
  removeOptionFees,
  getNewOtherFeesList,
  getSingleNewOtherFees,
  history,
  optionCalculationList,
  getOptionCalculationList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getOptionCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getOptionCalculationList(newOtherFeesId);
  }, [newOtherFeesId]);

  const handleAddOptionModal = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <CreateOptionModal
          newOtherFeesId={newOtherFeesId}
          optionCalculationList={optionCalculationList}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Option Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEditOptionModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateOptionModal
          newOtherFeesId={newOtherFeesId}
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          optionCalculationList={optionCalculationList}
        />
      ),
      title: 'Update Option Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveOption = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to remove this option fee?',
      () => {
        removeOptionFees(data.id, newOtherFeesId, () => {
          getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
          history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
          getSingleNewOtherFees(newOtherFeesId);
          getOptionCalculationList(newOtherFeesId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div>
      <div className="p-3">
        <div className="ml-auto text-right mb-3">
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
            onClick={handleAddOptionModal}
          >
            Add Option Calculation
          </button>
        </div>
        <table className="transaction-table table table-bordered table-sm table-striped table-hover">
          <thead>
            <tr>
              <td>Multiplier</td>
              <td>Amount</td>
              <td className="text-center">Action</td>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(optionCalculationList) ? (
              optionCalculationList.map((item) => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.multiplier')}
                  </td>
                  <td className="text-left">
                    {_.get(item, 'attributes.amount')}
                  </td>
                  <td className="text-right">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEditOptionModal(item)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveOption(item)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

OptionCalculation.propTypes = {
  optionCalculationList: PropTypes.instanceOf(Object).isRequired,
  removeOptionFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getOptionCalculationList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  optionCalculationList:
    _.get(api, `${c.GET_OPTION_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OptionCalculation);
